import React from 'react';
import PropTypes from 'prop-types';
import { RefreshIndicator } from 'material-ui';
import { connect } from 'react-redux';

import styles from './styles.scss';
import ResponseListFilters from './ResponseListFilters';
import ResponseListRenderer from './ResponseListRenderer';
import ResponseDetailsRenderer from './ResponseDetailsRenderer';

@connect(state => ({
  viewport: state.Responsive.get('viewport'),
  windowHeight: state.Responsive.get('windowHeight'),
}))
export default class Responses extends React.Component {
  static propTypes = {
    viewport: PropTypes.string.isRequired,
    match: PropTypes.shape({
      params: PropTypes.object,
    }).isRequired,
    windowHeight: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      onClient: false,
    };
  }

  componentDidMount() {
    this.setState({ onClient: true }); // eslint-disable-line react/no-did-mount-set-state
  }

  render() {
    const {
      windowHeight, match: { params: { responseId: activeResponse } }, viewport } = this.props;
    const { onClient } = this.state;
    const top = ((windowHeight - 161) / 2) + 161;

    const loadingEl = (<div>
      <ResponseListFilters updateFilter={() => null} />
      <RefreshIndicator top={top} left={277} status='loading' />
    </div>);

    const ActiveResponse = <ResponseDetailsRenderer activeResponse={activeResponse} />;

    if (viewport !== 'desktop' && activeResponse) {
      return ActiveResponse;
    }

    return (<div className={styles.container}>
      <div className={styles.list}>
        {onClient ? <ResponseListRenderer
          activeResponse={activeResponse} loadingEl={loadingEl}
        /> : loadingEl}
      </div>
      <div className={styles.detail}>{activeResponse ? ActiveResponse : null}</div>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Forms/Responses.js